import { takeEvery, put, call } from "redux-saga/effects";

import {
  getTechniciansAPI,
  addTechnicianAPI,
  getTechnicianAPI,
  updateTechnicianAPI,
  deleteUserAPI,
  updateBlockStatusAPI,
  getTechnicianPurchasesAPI,
  changeTechnicianRemainingCallsAPI,
} from "../../../helpers/backend.helper";
import {
  GET_TECHNICIANS,
  ADD_TECHNICIAN,
  GET_TECHNICIAN,
  UPDATE_TECHNICIAN,
  DELETE_TECHNICIAN,
  UPDATE_BLOCK_STATUS,
  GET_TECHNICIAN_PURCHASES,
  CHANGE_TECHNICIAN_REMAINING_CALLS,
} from "./actionTypes";
import {
  addTechnicianError,
  addTechnicianSuccess,
  deleteTechnicianError,
  deleteTechnicianSuccess,
  getTechnicianError,
  getTechniciansError,
  getTechniciansSuccess,
  getTechnicianSuccess,
  updateTechnicianError,
  updateTechnicianSuccess,
  updateBlockStatusSuccess,
  updateBlockStatusError,
  getTechnicianPurchasesSuccess,
  getTechnicianPurchasesError,
  changeTechnicianRemainingCallsSuccess,
  changeTechnicianRemainingCallsError,
} from "./actions";

function* getTechnicians({ payload: { request } }) {
  try {
    const response = yield call(getTechniciansAPI, request);
    if (response) {
      yield put(getTechniciansSuccess(response?.data));
    }
  } catch (error) {
    yield put(getTechniciansError(error));
  }
}

function* addTechnician({ payload: { request } }) {
  try {
    const response = yield call(addTechnicianAPI, request);
    if (response) {
      yield put(addTechnicianSuccess());
    }
  } catch (error) {
    yield put(addTechnicianError(error));
  }
}

function* getTechnician({ payload: { id } }) {
  try {
    const response = yield call(getTechnicianAPI, id);
    if (response) {
      yield put(getTechnicianSuccess(response?.data));
    }
  } catch (error) {
    yield put(getTechnicianError(error));
  }
}

function* updateTechnician({ payload: { request } }) {
  try {
    const response = yield call(updateTechnicianAPI, request);
    if (response) {
      yield put(updateTechnicianSuccess());
    }
  } catch (error) {
    yield put(updateTechnicianError(error));
  }
}

function* deleteTechnician({ payload: { id } }) {
  try {
    const response = yield call(deleteUserAPI, id);
    if (response) {
      yield put(deleteTechnicianSuccess());
    }
  } catch (error) {
    yield put(deleteTechnicianError(error));
  }
}

function* updateBlockStatus({ payload: { request } }) {
  try {
    const response = yield call(updateBlockStatusAPI, request);
    if (response) {
      yield put(updateBlockStatusSuccess());
    }
  } catch (error) {
    yield put(updateBlockStatusError(error));
  }
}

function* getTechnicianPurchases({ payload: { id } }) {
  try {
    const response = yield call(getTechnicianPurchasesAPI, id);
    if (response) {
      yield put(getTechnicianPurchasesSuccess(response?.data));
    }
  } catch (error) {
    yield put(getTechnicianPurchasesError(error));
  }
}

function* changeTechnicianRemainingCalls({ payload: { request } }) {
  try {
    const response = yield call(changeTechnicianRemainingCallsAPI, request);
    if (response) {
      yield put(changeTechnicianRemainingCallsSuccess(response?.data));
    }
  } catch (error) {
    yield put(changeTechnicianRemainingCallsError(error));
  }
}

function* technicianSaga() {
  yield takeEvery(GET_TECHNICIANS, getTechnicians);
  yield takeEvery(ADD_TECHNICIAN, addTechnician);
  yield takeEvery(GET_TECHNICIAN, getTechnician);
  yield takeEvery(UPDATE_TECHNICIAN, updateTechnician);
  yield takeEvery(DELETE_TECHNICIAN, deleteTechnician);
  yield takeEvery(UPDATE_BLOCK_STATUS, updateBlockStatus);
  yield takeEvery(GET_TECHNICIAN_PURCHASES, getTechnicianPurchases);
  yield takeEvery(
    CHANGE_TECHNICIAN_REMAINING_CALLS,
    changeTechnicianRemainingCalls
  );
}

export default technicianSaga;
